import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import MarathonsContent from '../../../components/Pages/Marathons/Diploma';

const { displayName } = config;

export default function MarathonDiploma(): React.ReactNode | null {
  document.title = `${displayName}: Редактировать диплом`;

  return (
    <Layout>
      <MarathonsContent />
    </Layout>
  );
}
